import { ReactNode } from 'react';
import { FormActionsStatus, FormRequestSort, TeacherRecommendationStatus } from '@youscience/commonapp-service-common';

import { HeadCell } from '@interfaces/recommenderWorkspace';
import { Order } from '@interfaces';

import { Color } from '@components/Chip';

import SubmittedIcon from '@images/Recommender/submitted.svg?react';
import InProgressIcon from '@images/Recommender/in-progress.svg?react';
import AvailableIcon from '@images/Recommender/form-available.svg?react';
import NoOptionsIcon from '@images/Recommender/no-option.svg?react';
import NotebookIcon from '@images/Recommender/notebook.svg?react';
import RequiredIcon from '@images/Recommender/required.svg?react';
import ErrorIcon from '@images/Recommender/error.svg?react';
import CancelIcon from '@images/Recommender/cancel.svg?react';
import CheckCircleIcon from '@images/Recommender/check-circle.svg?react';
import {
  FormAvailabilityStatus,
  FormCompletionStatus,
  FormRequiredStatus,
} from '@pages/StudentDetailsPage/components/common/enums';

export const HEAD_CELLS: HeadCell[] = [
  {
    id: 'legalName',
    label: 'Legal Name',
  },
  {
    id: 'deadline',
    label: 'Application deadline',
  },
  {
    id: 'actionsRequired',
    label: 'Required forms',
  },
  {
    id: 'status',
    label: 'Application status',
  },
];

export const STATUS_CHIP_COLORS: Record<FormActionsStatus | TeacherRecommendationStatus | FormCompletionStatus, Color> =
  {
    [FormActionsStatus.NEW]: 'error',
    [FormActionsStatus.IN_PROGRESS]: 'info',
    [FormActionsStatus.SUBMITTED]: 'success',
    [TeacherRecommendationStatus.NOT_STARTED]: 'error',
    [TeacherRecommendationStatus.PENDING]: 'default',
    [TeacherRecommendationStatus.REJECTED]: 'warning',
    [FormCompletionStatus.PENDING]: 'default',
    [FormCompletionStatus.DOWNLOADED]: 'success',
  };

export const SCHOOL_REQUIREMENTS_DATA: Record<string, { icon: ReactNode; subtitle: string }> = {
  [FormCompletionStatus.SUBMITTED]: {
    icon: <SubmittedIcon />,
    subtitle: FormCompletionStatus.SUBMITTED,
  },
  [FormCompletionStatus.DOWNLOADED]: {
    icon: <SubmittedIcon />,
    subtitle: FormCompletionStatus.DOWNLOADED,
  },
  [FormCompletionStatus.IN_PROGRESS]: {
    icon: <InProgressIcon />,
    subtitle: FormCompletionStatus.IN_PROGRESS,
  },
  [FormRequiredStatus.REQUIRED]: {
    icon: <RequiredIcon />,
    subtitle: FormRequiredStatus.REQUIRED,
  },
  [FormRequiredStatus.OPTIONAL]: {
    icon: <NotebookIcon />,
    subtitle: FormRequiredStatus.OPTIONAL,
  },
  [FormAvailabilityStatus.AVAILABLE]: {
    icon: <AvailableIcon />,
    subtitle: FormAvailabilityStatus.AVAILABLE,
  },
  [FormAvailabilityStatus.NOT_YET_AVAILABLE]: {
    icon: <NotebookIcon />,
    subtitle: FormAvailabilityStatus.NOT_YET_AVAILABLE,
  },
  [FormAvailabilityStatus.NOT_AVAILABLE]: {
    icon: <NoOptionsIcon />,
    subtitle: FormAvailabilityStatus.NOT_AVAILABLE,
  },
};

export const SORT_OPTIONS: Record<string, Record<Order, undefined | FormRequestSort>> = {
  legalName: {
    [Order.asc]: FormRequestSort.NAME_ASC,
    [Order.desc]: FormRequestSort.NAME_DESC,
  },
  deadline: {
    [Order.asc]: FormRequestSort.DEADLINE_EARLIEST,
    [Order.desc]: FormRequestSort.DEADLINE_LATEST,
  },
  status: {
    [Order.asc]: FormRequestSort.STATUS_ASC,
    [Order.desc]: FormRequestSort.STATUS_DESC,
  },
};

export const SUMMARY_UPDATES_LABELS = {
  classRank: 'Class rank',
  gpa: 'GPA',
  transcripts: 'Updated transcript or predicted grades',
};

export const OTHER_UPDATES_LABELS = {
  enrolledCourses: "Change in student's enrolled courses",
  evaluation: 'Change to my evaluation',
  otherCorrection: 'Other correction or update',
};

export const TEACHER_EVALUATION_STATUS_DATA: Record<TeacherRecommendationStatus, { icon: ReactNode; title: string }> = {
  [TeacherRecommendationStatus.IN_PROGRESS]: {
    icon: null,
    title: '',
  },
  [TeacherRecommendationStatus.NOT_STARTED]: {
    icon: null,
    title: '',
  },
  [TeacherRecommendationStatus.PENDING]: {
    icon: <ErrorIcon />,
    title: 'Pending approval',
  },
  [TeacherRecommendationStatus.REJECTED]: {
    icon: <CancelIcon />,
    title: 'Rejected',
  },
  [TeacherRecommendationStatus.SUBMITTED]: {
    icon: <CheckCircleIcon />,
    title: 'Submitted',
  },
};
